export const LISTING_TYPES = [
  { value: 'sell', label: 'Sell', desc: 'List industrial items you want to sell' },
  { value: 'wanted', label: 'Wanted', desc: 'Post a buy requirement' },
  { value: 'rent', label: 'Rent', desc: 'Rent out industrial equipment' },
];

export const CONDITIONS_SELL = ['New', 'Like New', 'Used', 'Refurbished', 'Old / As Is'];
export const CONDITIONS_WANTED = ['New', 'Used', 'Any'];

export const PRICE_TYPES = ['Fixed Price', 'Negotiable', 'Price on Request'];
export const URGENCY_TYPES = ['Immediate', 'This Month', 'Flexible'];
export const BUDGET_TYPES = ['Budget Mentioned', 'Budget Flexible', 'Not Disclosed'];
export const RENT_PRICING_TYPES = ['Per Day', 'Per Week', 'Per Month', 'Custom Quote'];
export const AVAILABILITY_TYPES = ['Available', 'Limited', 'On Request'];

// Industrial unit dropdown used across Sell / Wanted / Rent listing forms.
// Organized loosely by measurement type for readability. See #5 in Review.pdf.
export const UNIT_OPTIONS = [
  { group: 'Count',      value: 'Pcs',            label: 'Pcs (Pieces)' },
  { group: 'Count',      value: 'Nos',            label: 'Nos (Numbers)' },
  { group: 'Count',      value: 'Unit',           label: 'Unit' },
  { group: 'Count',      value: 'Set',            label: 'Set' },
  { group: 'Count',      value: 'Pair',           label: 'Pair' },
  { group: 'Count',      value: 'Dozen',          label: 'Dozen' },
  { group: 'Weight',     value: 'Kg',             label: 'Kg (Kilogram)' },
  { group: 'Weight',     value: 'Gram',           label: 'Gram' },
  { group: 'Weight',     value: 'Ton',            label: 'Ton (Metric Ton)' },
  { group: 'Weight',     value: 'Quintal',        label: 'Quintal (100 kg)' },
  { group: 'Volume',     value: 'Litre',          label: 'Litre' },
  { group: 'Volume',     value: 'Millilitre',     label: 'Millilitre (ml)' },
  { group: 'Length',     value: 'Metre',          label: 'Metre (m)' },
  { group: 'Length',     value: 'Foot',           label: 'Foot (ft)' },
  { group: 'Length',     value: 'Inch',           label: 'Inch' },
  { group: 'Length',     value: 'Yard',           label: 'Yard' },
  { group: 'Length',     value: 'Km',             label: 'Kilometre (km)' },
  { group: 'Area',       value: 'Sqft',           label: 'Sq. Ft.' },
  { group: 'Area',       value: 'Sqm',            label: 'Sq. Metre' },
  { group: 'Area',       value: 'Sqyd',           label: 'Sq. Yard' },
  { group: 'Volume 3D',  value: 'Cubic Metre',    label: 'Cubic Metre (m³)' },
  { group: 'Volume 3D',  value: 'Cubic Foot',     label: 'Cubic Foot (cft)' },
  { group: 'Packaging',  value: 'Box',            label: 'Box' },
  { group: 'Packaging',  value: 'Carton',         label: 'Carton' },
  { group: 'Packaging',  value: 'Bag',            label: 'Bag' },
  { group: 'Packaging',  value: 'Bundle',         label: 'Bundle' },
  { group: 'Packaging',  value: 'Bale',           label: 'Bale' },
  { group: 'Packaging',  value: 'Roll',           label: 'Roll' },
  { group: 'Packaging',  value: 'Reel',           label: 'Reel' },
  { group: 'Packaging',  value: 'Coil',           label: 'Coil' },
  { group: 'Packaging',  value: 'Drum',           label: 'Drum' },
  { group: 'Packaging',  value: 'Barrel',         label: 'Barrel' },
  { group: 'Packaging',  value: 'Container',      label: 'Container' },
  { group: 'Packaging',  value: 'Pallet',         label: 'Pallet' },
  { group: 'Machinery',  value: 'KW',             label: 'KW (Kilowatt)' },
  { group: 'Machinery',  value: 'kVA',            label: 'kVA' },
  { group: 'Machinery',  value: 'HP',             label: 'HP (Horsepower)' },
  { group: 'Other',      value: 'Lot',            label: 'Lot' },
  { group: 'Other',      value: 'Job',            label: 'Job' },
  { group: 'Other',      value: 'Other',          label: 'Other (see description)' },
];

export const STATUS_LABELS = {
  draft: 'Draft',
  submitted: 'Submitted',
  pending_review: 'Pending Review',
  approved: 'Approved',
  live: 'Live',
  rejected: 'Rejected',
  needs_correction: 'Needs Correction',
  flagged: 'Flagged',
  suspended: 'Suspended',
  expired: 'Expired',
};

export const REPORT_REASONS = [
  { value: 'fake_listing', label: 'Fake listing' },
  { value: 'wrong_category', label: 'Wrong category' },
  { value: 'spam', label: 'Spam' },
  { value: 'sold_unavailable', label: 'Sold / Unavailable' },
  { value: 'suspicious_seller', label: 'Suspicious seller' },
  { value: 'prohibited_content', label: 'Prohibited content' },
  { value: 'other', label: 'Other' },
];

export const VERIFICATION_DOCS = [
  { value: 'gst', label: 'GST Certificate' },
  { value: 'company_registration', label: 'Company Registration Proof' },
  { value: 'msme_udyam', label: 'MSME / Udyam Certificate' },
  { value: 'business_pan', label: 'Business PAN' },
  { value: 'other', label: 'Other Supporting Document' },
];
